(function() {
    'use strict';

    angular.module('remitEventsApp', [
        'LocalStorageModule',
        'tmh.dynamicLocale',
        'pascalprecht.translate',
        'ui.bootstrap',
        'ngResource',
        'ui.router',
        'ngCookies',
        'ngAria',
        'ngCacheBuster',
        'ngFileUpload',
        'infinite-scroll',
        'angularMoment',
        'angularCSS',
        'ui.bootstrap.datetimepicker',
        'blockUI',
        'remitEventsFilters',
        'ngSanitize'
    ]);
})();
